/** @format */

import GridItem from '../../../../../components/Grid/GridItem';
import I18n from '../../../../../components/Translate/I18n';
import GridContainer from '../../../../../components/Grid/GridContainer';
import CheckBoxSimple from '../../../../../components/Form/CheckBoxSimple';
import CustomInputExtNumber from '../../../../../components/CustomInput/CustomInputExtNumber';
import CustomTextButtom from '../../../../../components/Buttons/CustomTextButton';
import React, { useState } from 'react';

interface MultiInputPropsInterface {
    parameter: any;
    parameterKey: string;
    createValuesFromForm: (paramName: string, objectValue: object) => void | null;
    assignedValue?: any;
    isBME?: boolean;
}

export const MultiInput = (props: MultiInputPropsInterface): React.ReactElement => {
    const { parameter, parameterKey, createValuesFromForm, isBME, assignedValue } = props;
    const getValueOrArrayOfValues = (item: any): Array<number> => {
        if (item) {
            if (Array.isArray(item)) {
                return item.map((el: any) => el.value);
            } else {
                return [item];
            }
        }
        return [];
    };
    const [inputValue, setInputValue] = useState<number | null>(null);
    const [inputValueArr, setInputValueArr] = useState<Array<number>>(assignedValue ? getValueOrArrayOfValues(assignedValue.allowedValue) : []);
    const [checkedIndexes, setCheckedIndexes] = useState<Array<number>>(
        assignedValue ? assignedValue.allowedValue.map((el: any, indx: any) => indx) : []
    );
    const [isRequired, setIsRequired] = useState<boolean>(assignedValue ? assignedValue.required : props.parameter.required);

    return (
        <GridContainer style={{ paddingBottom: 25 }}>
            <GridItem xs={4}>
                <I18n trans={'prov:feature.param_name'} valueObject={{ param_name: props.parameterKey }} />
            </GridItem>
            <GridItem xs={8}>
                <GridContainer>
                    <GridItem xs={6}>
                        <GridItem xs={12}>
                            <CheckBoxSimple
                                label={'prov:feature.required'}
                                checked={isRequired}
                                callback={(): void => {
                                    setIsRequired(!isRequired);
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <CustomInputExtNumber
                                labelText={'prov:feature.default'}
                                name="default"
                                value={inputValue}
                                onChange={(event: any): void => {
                                    setInputValue(event.target.value);
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <CustomTextButtom
                                callback={(): void => {
                                    if (inputValue !== null) {
                                        setInputValueArr([...inputValueArr, inputValue]);
                                        setInputValue(null);
                                    }
                                }}
                                callbackParam={{}}
                                label="prov:feature.add_custom_amount"
                                size="sm"
                            />
                        </GridItem>
                    </GridItem>
                    <GridItem xs={6}>
                        <GridItem xs={12}>
                            <I18n trans={'prov:feature.allowed_value'} />
                        </GridItem>

                        {inputValueArr.map((el, indx) => {
                            return (
                                <GridItem xs={12} key={`${el}_${indx}`}>
                                    <CheckBoxSimple
                                        label={el.toString()}
                                        checked={checkedIndexes.includes(indx)}
                                        callback={(): void => {
                                            if (!checkedIndexes.includes(indx)) {
                                                const x = [...checkedIndexes, indx];
                                                setCheckedIndexes(x);
                                                const items = inputValueArr.filter((el, index) => {
                                                    if (x.includes(index)) {
                                                        return el;
                                                    }
                                                });
                                                let finalObject = {
                                                    default: null,
                                                    allowedValue: items.map((el): object => {
                                                        return { value: el };
                                                    }),
                                                    required: isRequired,
                                                };
                                                props.createValuesFromForm(props.parameterKey, finalObject);
                                            } else {
                                                const newChecked = checkedIndexes.filter((el) => {
                                                    return el !== indx;
                                                });
                                                setCheckedIndexes(newChecked);
                                                const items = inputValueArr.filter((el, index) => {
                                                    if (newChecked.includes(index)) {
                                                        return el;
                                                    }
                                                });
                                                let finalObject = {
                                                    default: null,
                                                    allowedValue: items.map((el): object => {
                                                        return { value: el };
                                                    }),
                                                    required: isRequired,
                                                };
                                                props.createValuesFromForm(props.parameterKey, finalObject);
                                            }
                                        }}
                                    />
                                </GridItem>
                            );
                        })}
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
